<!-- 

URL: /financeiro/posicaofinanceiro

-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Filtro from "../consultas/filtro"
import Chart from "./chart"
import { apiORDSpost, apiDownload2 } from '../shared/api-functions'

export default {
    components: {
        BarList, BarGrid, FilterList, Filtro
    },

    data () {
        return {
            data: null,
            total: null,
            codpart: null,
            codcta: null,
            tipo: 'R',
            tipoOptions: [{ id: 'R', text: "A Receber" }, { id: 'P', text: "A Pagar" }],
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            paramFiltro: null,
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }],
            }          
        }
    },

    computed: {
        paramsChart: function () {            
            if (!this.grafico)
                return null

            let grafico = []
            grafico.push(this.grafico.labels[0])

            for (var x = 0; x < this.grafico.length; x++) {
                grafico.push([this.grafico[x].descricao, this.grafico[x].valor])
            }

            return { 
                chart: { type: 'PieChart' }, 
                values: grafico 
            }
        },

        dataFilter() {
            const data = this.data
            const param = this.paramFiltro

            if (param) {
                return data.filter((obj) => {
                    if (param == 'aberto' && obj.aberto) return true
                    if (param == 'baixado' && obj.baixado) return true
                    if (param == 'vencido' && obj.vencido) return true
                    if (param == 'cancelado' && obj.cancelado) return true
                })
            }

            return data
        }
    },


    watch: {
        
    },

    methods: {
        loadData(excel) {
            let url = "consulta/vendas/posicaofinanceiro";

            this.periodo.data_inicio = this.periodo.startDate
            this.periodo.data_termino = this.periodo.endDate
            this.filtro.tipo = this.tipo
            this.filtro.codcta = this.codcta
            this.filtro.codpart = this.codpart
            this.filtro.periodos = [ this.periodo ]
            this.filtro.excel = excel;


            if (excel) 
                apiDownload2(this, url, this.filtro, "post")
            else {
                let self = this
                apiORDSpost(this.$store, url, this.filtro, "post").then((data) => {
                    if (data) {
                        self.total = data.total
                        self.data = data.dados
                    }
                })
            }
        },

        filtrarTitulos(payload) {
            if (payload === 0) {
                this.paramFiltro = null
                return
            }

            if (payload === 1) {
                this.paramFiltro = 'vencido'
                return
            }

            if (payload === 2) {
                this.paramFiltro = 'aberto'
                return
            }

            if (payload === 3) {
                this.paramFiltro = 'cancelado'
                return
            }

            if (payload === 4) {
                this.paramFiltro = 'baixado'
                return
            }
        }
    },

    filters: {

    },

    mounted () {
      this.loadData();
    },

    created () {
        this.periodo.data_inicio = this.$firstDay(this.$getDate())
        this.periodo.data_termino = this.$lastDay(this.$getDate())
        this.periodo.startDate = this.$firstDay(this.$getDate())
        this.periodo.endDate = this.$lastDay(this.$getDate())
        // this.loadData(false)
    }
}
</script>

<template>
    <div>
        <div class="default-container">
            <div class="row">
                <div class="col-12">
                    <span class="lbl-deal-title mb-2 w-100">
                        POSIÇÃO DE CONTAS
                    </span>
                </div>
            </div>

            <hr />
            
            <!-- Filtro -->
            <div class="row">
                <div class="col-md-6">
                    <v-label label="Período"></v-label>
                    <input-month2 :p-month="periodo"></input-month2>
                </div>
                <div class="col-md-6">
                    <form-field v-model="codpart" type="select2" label="Cliente/Fornecedor" 
                    :select2="{entity: 'part', minlength: 0}"></form-field>
                </div>
                <div class="col-md-6">
                    <form-field v-model="codcta" type="select2" label="Conta" 
                    :select2="{entity: 'cta', minlength: 0}"></form-field>
                </div>
               <div class="col-md-6">
                <form-field v-model="tipo" type="select" label="Tipo de Fluxo"
                    :select-options="tipoOptions"></form-field>
                </div>                
            </div>
            <div class="row">
                <div class="col-12 d-flex flex-row-reverse mb-2">
                    <v-button label="Filtrar" :success="true" @click="loadData"></v-button>
                    <!-- <v-button title="Atualizar Grid" icon="fa-refresh" @click="loadData"></v-button> -->
                    <v-button label="Excel" @click="loadData(true)"></v-button>
                </div>
            </div>
            
            <hr />

            <!-- Totais -->
            <div class="row totais d-flex justify-content-between align-items-center" v-if="total">
                <div class="col-12 col-md-2">
                    <h2>Totais</h2>
                </div>
                <div class="col-12 col-md-10 d-flex flex-wrap justify-content-end align-items-center">
                    <div class="total flex-fill">
                        <p>Cancelados</p>
                        <div class="d-flex justify-content-end align-items-baseline">
                            <small v-if="total.cancelados > 0">R$</small>
                            <span class="text-danger" @click="filtrarTitulos(3)">
                                {{ total.cancelados | formatValue(2) }}
                            </span>
                        </div>
                    </div>
                    <div class="total flex-fill">
                        <p>Em Atraso</p>
                        <div class="d-flex justify-content-end align-items-baseline">
                            <small v-if="total.atrasados > 0">R$</small>
                            <span class="text-warning" @click="filtrarTitulos(1)">
                                {{ total.atrasados | formatValue(2) }}
                            </span>
                        </div>
                    </div>
                    <div class="total flex-fill bg-light">
                        <p>A Receber</p>
                        <div class="d-flex justify-content-end align-items-baseline">
                            <small v-if="total.abertos > 0">R$</small>
                            <span class="text-navy-blue" @click="filtrarTitulos(2)">
                                {{ total.abertos | formatValue(2) }}
                            </span>
                        </div>
                    </div>
                    <div class="total flex-fill bg-light">
                        <p>Recebidos</p>
                        <div class="d-flex justify-content-end align-items-baseline">
                            <small v-if="total.baixados > 0">R$</small>
                            <span class="text-success" @click="filtrarTitulos(4)">
                                {{ total.baixados | formatValue(2) }}
                            </span>
                        </div>
                    </div>
                    <div class="total flex-fill bg-light">
                        <p>Total do Período</p>
                        <div class="d-flex justify-content-end align-items-baseline">
                            <small v-if="total.total > 0">R$</small>
                            <span class="text-blue" @click="filtrarTitulos(0)">
                                {{ total.total | formatValue(2) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabela -->
            <div class="row" v-if="data">
                <div class="data-table col-12 lbl-title">
                    <table class="table table-bordered table-sm responsive w-100 bg-light">
                        <thead>
                            <tr>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Emissão
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Nr Documento / Parcela
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Natureza Financeira
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Cliente / Fornecedor
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Cancelamento
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Vencimento
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Pagamento
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Valor (R$)
                                </th>
                                <th colspan="1">
                                </th>
                            </tr>
                        </thead>
                        <tbody>                    
                            <tr v-for="(dado, index) in dataFilter" :key="index">
                                <th class="textual text-center value-bg-color">
                                    <span>
                                        {{dado.data | formatData}}
                                    </span>
                                </th>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{dado.doc}} / {{dado.parcela}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{dado.natureza}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{dado.nome}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span v-if="dado.cancelado" class="text-danger">
                                        {{dado.pagamento | formatData}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span :class="dado.vencido ? 'text-warning' : ''">
                                        {{dado.vencimento | formatData}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span v-if="!dado.cancelado">
                                        {{dado.pagamento | formatData}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{dado.vlr | formatValue(2)}}
                                    </span>
                                </td>
                                <td class="numerico size100 text-center value-bg-color">
                                    <i style="font-size: 1.1rem" class="fa fa-check fa-fw text-success py-2" v-if="dado.baixado"></i>
                                    <i style="font-size: 1.1rem" class="fa fa-clock-o fa-fw text-warning py-2" v-if="dado.vencido"></i>
                                    <i style="font-size: 1.1rem" class="fa fa-times fa-fw text-danger py-2" v-if="dado.cancelado"></i>
                                    <i style="font-size: 1.1rem" class="fa fa-money fa-fw text-primary py-2" v-if="dado.aberto && !dado.vencido"></i>
                                    <i style="font-size: 1.1rem" class="fa fa-exclamation-circle fa-fw text-danger py-2" v-if="dado.perdido"></i>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <!-- Table Footer -->
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <!-- Grafico -->
        <!-- <div  v-if="grafico.length > 0" class="col-md-4">
            <div class="border">
                <chart :params="paramsChart"></chart>
            </div>
        </div> -->
    </div>
</template>

<style scoped>

.text-navy-blue {
    color: #174b79 !important;
}

.text-blue {
    color: #2469a5 !important;
}

.total {
    padding: 0.5rem;
    min-width: 1.5rem;
}

.total p {
    color: #808080bb;
    text-align: end;
    font-size: .85rem;
    font-weight: bold;
    margin-bottom: -7.5px;
}

.total small {
    font-size: 1rem;
    font-weight: 500;
    padding-right: .25rem;
    color: #212529 !important;
}

.total span {
    text-align: end;
    font-size: 1.85rem;
    font-weight: bold;
    cursor: pointer;
}

.data-table {
    overflow: auto;
}

.data-table {
    overflow: auto;
}

table .textual {
    font-size: 12px;
    padding: 4.8px;
}

table .numerico {
    font-size: 12px;
    min-width: 65px;
    text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.value-bg-color {
    background-color: #fafffa !important;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-posicao-financeiro.vue